'use client'

import get from 'lodash/get'
import { ArrayWidget } from './widgets/arrayWidget'
import { CheckboxWidget } from './widgets/checkboxWidget'
import { DateWidget } from './widgets/dateWidget'
import { EmailWidget } from './widgets/emailWidget'
import { FileWidget } from './widgets/fileWidget'
import { MultiSelectWidget } from './widgets/multiSelectWidget'
import { NumberWidget } from './widgets/numberWidget'
import { PasswordWidget } from './widgets/passwordWidget'
import { RangeWidget } from './widgets/rangeWidget'
import { RichTextWidget } from './widgets/richTextWidget'
import { SelectWidget } from './widgets/selectWidget'
import { TagsWidget } from './widgets/tagsWidget'
import { TextWidget } from './widgets/textWidget'
import { TextareaWidget } from './widgets/textareaWidget'

export type AutoFormSchema = Array<{
  path: string
  component: string
  classNames?: Record<string, string>
  options?: Record<string, unknown>
}>

type AutoFormProps = {
  schema: AutoFormSchema
  prefix?: string
  initialValues?: Record<string, unknown>
}

export type AutoFormWidgetsProps = {
  path: string
  classNames?: Record<string, string>
  options?: Record<string, unknown>
  initialValue?: any
}

export type AutoFormWidgets = {
  [k: string]: React.FunctionComponent<AutoFormWidgetsProps>
}

const widgets: AutoFormWidgets = {
  array: ArrayWidget,
  checkbox: CheckboxWidget,
  date: DateWidget,
  email: EmailWidget,
  file: FileWidget,
  multiselect: MultiSelectWidget,
  number: NumberWidget,
  password: PasswordWidget,
  range: RangeWidget,
  richtext: RichTextWidget,
  select: SelectWidget,
  tags: TagsWidget,
  textarea: TextareaWidget,
  text: TextWidget,
}

export function AutoForm(props: AutoFormProps) {
  return props.schema.map((item, index) => {
    const Component = widgets[item.component]

    if (!Component) {
      return null
    }

    // Compute full path. When item.path is empty (e.g., array of primitives),
    // use only the prefix to avoid trailing dots like "field.0."
    const fullPath = props.prefix
      ? item.path
        ? `${props.prefix}.${item.path}`
        : props.prefix
      : item.path

    return (
      <Component
        key={`${item.path}-${index}`}
        path={fullPath}
        options={item.options}
        classNames={item.classNames}
        initialValue={get(props.initialValues, item.path)}
      />
    )
  })
}
